module.exports = __webpack_public_path__ + "media/images/logo-grey-9c64aa6f1cbffb5a96513cbc274f6479.svg";